<template>
    <div class="menuBar blurrable" :class="{'blurred': $root.modalWindowOpen}">
        <img class="logo" src="@/assets/images/saab-logo-white.svg" @click="$root.toggleFullscreen()">
        <div class="navigationMenu">
            <div class="naviationMenu__items">
                <router-link :to="{name: 'home'}">Home</router-link> |
                <router-link :to="{name: 'intro'}">DCIS Intro</router-link>
                <router-link @click.native="$root.$emit('reset-accordion')" :to="{name: 'scenario-menu'}" :class="{'router-link-exact-active': subIsActive('/scenario')}">Scenario Setups</router-link>
                <router-link :to="{name: 'keybenefits'}">Key benefits</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NavigationMenu',
    methods: {
        subIsActive(parentPath) {
            return false;
            const paths = Array.isArray(parentPath) ? parentPath : [parentPath];
            return paths.some(path => this.$route.path.indexOf(path) === 0);
        },
    },
}
</script>

<style lang="scss" scoped>
    .menuBar {
        display: flex;
        background-color: $colour__primary1;
        padding: 1rem;
        padding: 1rem 1.4rem;
    }

    .navigationMenu {
        float: right;
        flex-grow: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        a {
            padding: 0 1rem;
            border-left: 1px solid $white;

            &:last-of-type {
                padding-right: 0;
            }

            &:first-of-type {
                border-left: 0;
            }

            &:hover {
                color: $colour__accent1;
            }

        }
    }

    .logo {
        display: block;
        height: 3.4rem;
        flex-grow: 0;
    }

    a {
        color: $white;
        text-transform: uppercase;
        &.router-link-exact-active, &.router-link-active {
            color: $colour__accent1;
        }
    }
</style>
